//import { MotifTruncate } from "@ey-xd/motif-react";

import {
  MotifButton,
  MotifIcon,
  MotifTooltip,
  MotifChip,
} from "@ey-xd/motif-react";
import {
  IconoirEditPencil,
  IconoirKeyPlus,
  IconoirKeyBack,
  IconoirTrash,
} from "@ey-xd/motif-icon";
import { truncateString } from "../../../utils/common";

const useCustomCellRenderers = (
  setShowUpdateSkus: React.Dispatch<React.SetStateAction<boolean>>,
  setShowDeleteSkuModal: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedSku: React.Dispatch<React.SetStateAction<string>>,
  setShowPreviewSkus: React.Dispatch<React.SetStateAction<boolean>>,
  setShowGenerateKeyModal: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedSkuName: React.Dispatch<React.SetStateAction<string>>,
  handleKey: (sku: string, isAvailable?: boolean) => void,
  isConsumptionManager: boolean
) => {
  const skuListRenderers = {
    skuRenderer: function (params: any) {
      
      const { sku } = params.data;
      return (
        <>
          <div className="ccwp_sku_wrapper">
            <span
              className="motif-body2-default-regular text-bold-underline edit-sku-link"
              onClick={() => {
                setShowPreviewSkus(true);
                setSelectedSku(params.data.sku);
              }}
            >
              {sku}
            </span>
          </div>
        </>
      );
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    skuNameCellRenderer: function (params: any) {
      const { skuName, skuId } = params.data;
      return (
        <div style={{ height: "3rem", width: "100%" }}>
          <MotifTooltip
            contentClassName="tooltip-content"
            allowClick
            allowHover
            id={`tooltip-${skuId}`}
            placement="auto"
            trigger={
              <span aria-label="Tooltip">{truncateString(skuName, 20)}</span>
            }
            usePortal
            variant="default"
          >
            {skuName}
          </MotifTooltip>
        </div>
      );
    },
    editRenderer: function (params: any) {
      const {
        costMetricCd,
        sku,
        status,
        IsSkuApiKeyAvailable,
        skuName,
        showDeleteBtn,
      } = params.data;
      if (!sku) {
        return null;
      }
      return (
        <div className="action-col">
          <div
            onClick={(e) => {
              if (isConsumptionManager) return;
              e.stopPropagation();
              setShowUpdateSkus(true);
              setSelectedSku(sku);
            }}
            className={`ccwp_sku_editRenderer ${isConsumptionManager ? "disabled" : ""}`}
          >
            <MotifIcon iconFunction={IconoirEditPencil} size="20" />
          </div>
          {status === "Draft" && showDeleteBtn && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setSelectedSku(sku);
                setShowDeleteSkuModal(true);
              }}
              className="ccwp_sku_editRenderer"
            >
              <MotifIcon iconFunction={IconoirTrash} size="20" />
            </div>
          )}
          {status === "Active" && !costMetricCd?.startsWith("fix") && (
            <MotifTooltip
              contentClassName="tooltip-content"
              allowClick
              allowHover
              id={`tooltip-sku-key`}
              placement="auto"
              trigger={
                <MotifButton
                  className="ccwp_sku_editRenderer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedSkuName(skuName);
                    setShowGenerateKeyModal(true);
                    setSelectedSku(sku);
                    handleKey(sku, IsSkuApiKeyAvailable);
                  }}
                >
                  {IsSkuApiKeyAvailable ? (
                    <MotifIcon iconFunction={IconoirKeyBack} />
                  ) : (
                    <MotifIcon iconFunction={IconoirKeyPlus} size="20" />
                  )}
                </MotifButton>
              }
              usePortal
              variant="default"
            >
              {IsSkuApiKeyAvailable ? "View key" : "Generate Key"}
            </MotifTooltip>
          )}
        </div>
      );
    },
    updateStatusRenderer: function (params: any) {
      const { updateStatusCd, status } = params.data;
      if (status == "Active") {
        switch (updateStatusCd) {
          case "skuupdate_submitted":
            return (
              <MotifChip
                title="Pending Approval"
                variant="warning"
                dotSide="left"
              >
                Pending Approval
              </MotifChip>
            );
          case "skuupdate_pending":
            return (
              <MotifChip
                title="Scheduled for Publish"
                variant="success"
                dotSide="left"
              >
                Scheduled for Publish
              </MotifChip>
            );
          case "skuupdate_rejected":
            return (
              <MotifChip title="Rejected" variant="error" dotSide="left">
                Rejected
              </MotifChip>
            );
          default:
            return "---";
        }
      }
      else{
        return "---";
      }
    },
  };
  return skuListRenderers;
};
export default useCustomCellRenderers;
